import {
  ProductSearch,
  type Props as ProductSearchProps,
} from "@emerson/components/ProductSearch/ProductSearch";
import { useHasCatalogSearchShared } from "@shared/hooks/useHasCatalogSearchShared/useHasCatalogSearchShared";

import { CatalogResults } from "./CatalogResults/CatalogResults";
import {
  PopularProducts,
  type Props as PopularProductsProps,
} from "./PopularProducts/PopularProducts";

type PopularProductsRenderResultsParams = Parameters<PopularProductsProps["renderResults"]>;
type ProductSearchRenderResultsParams = Parameters<
  NonNullable<ProductSearchProps["renderResults"]>
>;

type SearchResults = PopularProductsRenderResultsParams[0] | ProductSearchRenderResultsParams[0];
type PinnedIds = PopularProductsRenderResultsParams[1] | ProductSearchRenderResultsParams[1];
type TotalCount = PopularProductsRenderResultsParams[2] | ProductSearchRenderResultsParams[2];
type IsLoadingNewResults =
  | PopularProductsRenderResultsParams[3]
  | ProductSearchRenderResultsParams[3];
type IsLoadingMoreResults =
  | PopularProductsRenderResultsParams[4]
  | ProductSearchRenderResultsParams[4];
type HandleClearFilters =
  | PopularProductsRenderResultsParams[5]
  | ProductSearchRenderResultsParams[5];
type HandleLoadMore = PopularProductsRenderResultsParams[6] | ProductSearchRenderResultsParams[6];

const CatalogPage = () => {
  const hasSearch = useHasCatalogSearchShared();

  const renderResults = (
    searchResults: SearchResults,
    pinnedIds: PinnedIds,
    totalCount: TotalCount,
    isLoadingNewResults: IsLoadingNewResults,
    isLoadingMoreResults: IsLoadingMoreResults,
    handleClearFilters: HandleClearFilters,
    handleLoadMore: HandleLoadMore
  ) => (
    <CatalogResults
      searchResults={searchResults}
      pinnedIds={pinnedIds}
      totalCount={totalCount}
      isLoadingNewResults={isLoadingNewResults}
      isLoadingMoreResults={isLoadingMoreResults}
      handleClearFilters={handleClearFilters}
      handleLoadMore={handleLoadMore}
    />
  );

  if (hasSearch) {
    return <ProductSearch hideFilterTags hideSearchField renderResults={renderResults} />;
  }

  return <PopularProducts hideFilterTags hideSearchField renderResults={renderResults} />;
};

export { CatalogPage };
